import { z } from 'zod';
import { sectionHasValue } from '../util';
export const baseTemperature = z.object({
    notChecked: z.boolean().optional(),
    temp: z.string().optional(),
    via: z.string().optional(),
});
export const baseTemperatureRefined = baseTemperature.refine((data) => data.notChecked || data.temp?.trim() || data.via?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const baseO2 = z.object({
    notChecked: z.boolean().optional(),
    o2Sat: z.string().optional(),
    flow: z.string().optional(),
    lpm: z.string().optional(),
    via: z.string().optional(),
    viaOther: z.string().optional(),
});
export const baseO2Refined = baseO2.refine((data) => sectionHasValue(data), {
    message: 'At least one answer is required',
    path: [],
});
export const baseRespiration = z.object({
    notChecked: z.boolean().optional(),
    resp: z.string().optional(),
    respReg: z.string().optional(),
    effort: z.string().optional(),
});
export const baseRespirationRefined = baseRespiration.refine((data) => sectionHasValue(data), {
    message: 'At least one answer is required',
    path: [],
});
export const basePulse = z.object({
    notChecked: z.boolean().optional(),
    pulse: z.string().optional(),
    pulseApical: z.string().optional(),
    pulseReg: z.string().optional(),
});
export const basePulseRefined = basePulse.refine((data) => data.notChecked || data.pulse?.trim() || data.pulseApical?.trim() || data.pulseReg?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const baseBloodSugar = z.object({
    notChecked: z.boolean().optional(),
    fasting: z.string().optional().nullable(),
    random: z.string().optional().nullable(),
    preMeal: z.string().optional().nullable(),
    postMeal: z.string().optional().nullable(),
    bedtime: z.string().optional().nullable(),
    timeSinceLastMeal: z.string().optional().nullable(),
});
export const baseBloodSugarRefined = baseBloodSugar.refine((data) => sectionHasValue(data), {
    message: 'At least one answer is required',
    path: [],
});
export const baseBloodPressure = z.object({
    notChecked: z.boolean().optional(),
    bloodPressures: z
        .array(z.object({
        systolic: z.string().optional(),
        diastolic: z.string().optional(),
        position: z.string().optional(),
        arm: z.string().optional(),
        option: z.string().optional(),
    }))
        .optional(),
});
